import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import getPersonRequirements from './GetPersonRequirementsData';
import getPersonRequirementsAdvanced from './GetPersonRequirementsAdvancedData';
import postEnrollmentMemberRequirementAdmin from './PostEnrollmentMemberRequirementAdminData';
import deletePersonRequirementEnrollment from './DeletePersonRequirementEnrollmentData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  filteredRoleList: []
};

const PersonRequirementsData = {
  INITIAL_STATE,
  getPersonRequirements,
  getPersonRequirementsAdvanced,
  postEnrollmentMemberRequirementAdmin,
  deletePersonRequirementEnrollment

};

export default PersonRequirementsData;